import React, { useState, useEffect, useMemo } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import axios from "axios";
import ClickAllRefreshButtons from "./ClickAllRefreshButtons";
import Hoot from "./Hoot";
import {toast} from "react-toastify";

function RegisterAndUpdateInstituteModal({
  update,
  update_url,
  get_data_url,
  toggle_btn,
  mainschoolcode, // <-- NOVO: opcional. Se vier definido via props, o campo fica bloqueado (não editável) no modal.
}) {
  const [show, setShow] = useState(false);

  const initialData = useMemo(
    () => ({
      name: "",
      email: "",
      phone: "",
      nif: "",
      country: "",
      address: "",
      state: "",
      representative_name: "",
      representative_email: "",
      licence_type: 0,
      mainschool: mainschoolcode || "", // <-- NOVO
    }),
    [mainschoolcode]
  );

  const [formData, setFormData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [loadingFetch, setLoadingFetch] = useState(false);
  const [error, setError] = useState(null);

  // Lista de escolas existentes no sistema (para popular o select de "Escola Principal")
  const [schools, setSchools] = useState([]);
  const [loadingSchools, setLoadingSchools] = useState(false);

  // Se veio via props, o campo de escola principal fica travado (read-only)
  const mainSchoolLocked = Boolean(mainschoolcode);

  const uiStyles = `
:root{
  --primary:#5b5cff;
  --primary2:#7c3aed;
  --border:#e6eaf2;
  --text:#0f172a;
  --muted:#64748b;
}

/* ===== MODAL DESIGN (igual ao outro) ===== */
.pretty-modal .modal-dialog{ max-width: 920px; }
@media (max-width: 768px){ .pretty-modal .modal-dialog{ max-width: 96vw; } }
.pretty-modal .modal-content{
  border-radius: 18px;
  border: 1px solid rgba(226,232,240,.95);
  box-shadow: 0 30px 90px rgba(2,6,23,.22);
  overflow: hidden;
}
.pretty-modal .modal-header{
  border-bottom: 1px solid rgba(226,232,240,.9);
  background:
    radial-gradient(1000px 260px at 20% 0%, rgba(91,92,255,.16), transparent 60%),
    radial-gradient(900px 240px at 95% 0%, rgba(124,58,237,.12), transparent 55%),
    #ffffff;
  padding: 14px 16px;
}
.pretty-modal .modal-title{
  font-weight: 650;
  color: var(--text);
  font-size: 1rem;
}
.pretty-modal .modal-body{
  padding: 14px 16px 12px;
  background: linear-gradient(180deg, rgba(248,250,252,.75), #ffffff 40%);
}

/*  BODY COM SCROLL (footer fora do scroll) */
.body-scroll{ 
  overflow-y: auto;
  padding-right: 4px;
  max-height:700px;
}

/*  Footer fixo do modal (fora do scroll) */
.pretty-modal .modal-footer{
  border-top: 1px solid rgba(226,232,240,.9);
  padding: 12px 16px;
  background: #ffffff;
}

/* Header layout */
.header-row{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:12px;
  flex-wrap:wrap;
}
.header-left{
  display:flex;
  align-items:center;
  gap:12px;
}
.avatar-wrap{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(91,92,255,.10);
  border: 1px solid rgba(91,92,255,.18);
  display:grid;
  place-items:center;
}
.title-sub{
  margin-top:2px;
  font-size: .8rem;
  color: var(--muted);
  font-weight: 500;
}

/* Form layout */
.form-grid{
  display:grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 12px;
}
@media (max-width: 720px){ .form-grid{ grid-template-columns: 1fr; } }
.cardlet{
  background: rgba(255,255,255,.9);
  border: 1px solid rgba(226,232,240,.95);
  border-radius: 16px;
  padding: 10px 12px;
}
.cardlet-title{
  font-size: .78rem;
  color: var(--muted);
  font-weight: 600;
  display:flex;
  align-items:center;
  gap:8px;
  margin-bottom: 8px;
}
.req{ color:#ef4444; font-weight:700; }
.form-label{
  font-size: .78rem !important;
  color: #475569 !important;
  font-weight: 600 !important;
  margin-bottom: 6px !important;
}
.form-control, .form-select{
  border-radius: 12px !important;
  border-color: rgba(226,232,240,.95) !important;
  padding-top: .55rem !important;
  padding-bottom: .55rem !important;
}
.form-control:focus, .form-select:focus{
  box-shadow: 0 0 0 .2rem rgba(91,92,255,.15) !important;
  border-color: rgba(91,92,255,.45) !important;
}
.helper{ font-size: .74rem; color: var(--muted); margin-top: 6px; }
.locked-pill{
  display:inline-flex;
  align-items:center;
  gap:6px;
  font-size:.72rem;
  font-weight:600;
  color:#7c3aed;
  background:rgba(124,58,237,.1);
  border:1px solid rgba(124,58,237,.2);
  padding:2px 10px;
  border-radius:999px;
}

/* Footer actions */
.actions{ display:flex; justify-content:flex-end; gap:10px; flex-wrap:wrap; width:100%; }
.btn-soft{
  border-radius: 999px !important;
  border: 1px solid rgba(226,232,240,.95) !important;
  background: #fff !important;
}
.btn-primary{ border-radius: 999px !important; }
`;

  // Busca a lista de escolas existentes (usada para popular o select e/ou confirmar a escola-mãe)
  const fetchSchools = async () => {
    try {
      const res = await axios.get(Hoot() + "institutes", { withCredentials: true });
      return res.data;
    } catch {
      return [];
    }
  };

  useEffect(() => {
    if (!show) return;

    // Carrega sempre a lista de escolas quando o modal abre:
    // - se não vier mainschoolcode via props, é usada para o select "Escola Principal"
    // - se vier via props, é usada só para confirmar/mostrar o nome da escola-mãe
    setLoadingSchools(true);
    fetchSchools()
      .then((data) => setSchools(Array.isArray(data) ? data : []))
      .finally(() => setLoadingSchools(false));

    // abrir em modo create
    if (!update) {
      setFormData(initialData);
      setError(null);
      return;
    }

    // abrir em modo update: buscar dados
    if (update && get_data_url) {
      setError(null);
      setLoadingFetch(true);

      axios
        .get(get_data_url, { withCredentials: true })
        .then((response) => {
          setFormData({
            name: response.data.name ?? "",
            email: response.data.email ?? "",
            phone: response.data.phone ?? "",
            nif: response.data.nif ?? "",
            country: response.data.country ?? "",
            address: response.data.address ?? "",
            state: response.data.state ?? "",
            representative_name: response.data.representative_name ?? "",
            representative_email: response.data.representative_email ?? "",
            licence_type: response.data.licence_type ?? 0,
            mainschool:
              mainschoolcode ??
              response.data.mainschool ??
              response.data.ed_institute_mainschoolcode ??
              "",
          });
        })
        .catch((err) => {
          setError("Erro ao carregar dados da instituição.");
          toast.error("Erro ao carregar dados da instituição.");
          console.error(err);
        })
        .finally(() => setLoadingFetch(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, update, get_data_url, initialData, mainschoolcode]);

  const closeModal = () => {
    if (loading || loadingFetch) return;
    setShow(false);
    setError(null);
  };

  // Nome da escola-mãe (para mostrar quando o código vem travado via props)
  const lockedSchoolName = useMemo(() => {
    if (!mainSchoolLocked) return null;
    const found = schools.find(
      (s) => String(s.ed_institute_code) === String(mainschoolcode)
    );
    return found ? found.ed_institute_name : null;
  }, [schools, mainSchoolLocked, mainschoolcode]);

  // Gera e descarrega um ficheiro .txt organizado com os dados retornados pelo endpoint de registo
  const downloadInstituteReport = (data) => {
    try {
      const institute = data.institute || {};
      const login = data.login || {};
      const licence = data.licence || {};
      const employee = data.employee || {};

      const line = (label, value) => `${label.padEnd(28, " ")}: ${value ?? "-"}`;
      const sep = "=".repeat(64);
      const sub = "-".repeat(64);

      const content = `
${sep}
   COMPROVATIVO DE REGISTO - INSTITUIÇÃO EDUALL
${sep}

${line("Nome da Instituição", institute.name)}
${line("Código", institute.code)}
${line("Email", institute.email)}
${line("Telefone", institute.phone)}
${line("NIF", institute.nif)}
${line("País", institute.country)}
${line("Província / Estado", institute.state)}
${line("Endereço", institute.address)}
${line("Código Escola Principal", institute.mainSchoolCode || "-")}

${sub}
DADOS DE ACESSO (GUARDE ESTA INFORMAÇÃO EM LOCAL SEGURO)
${sub}

${line("Utilizador (username)", login.username)}
${line("Email de acesso", login.email)}
${line("Senha", login.password)}
${line("ID do Utilizador", login.userId)}

${sub}
REPRESENTANTE / FUNCIONÁRIO
${sub}

${line("Nome", employee.ed_employee_name)}
${line("Email", employee.ed_employee_email)}
${line("Código", employee.ed_employee_code)}

${sub}
LICENÇA
${sub}

${line("Tipo", licence.ed_institute_licence_type)}
${line("Código", licence.ed_institute_licence_code)}
${line("Data de início", licence.ed_institute_licence_startDate)}

${sep}
Gerado em: ${new Date().toLocaleString("pt-PT")}
${sep}
`.trim();

      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const safeName = (institute.name || "instituicao").replace(/[^a-z0-9]+/gi, "_");
      link.download = `registo_${safeName}_${institute.code || Date.now()}.txt`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (e) {
      console.error("Erro ao gerar ficheiro de registo:", e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    setError(null);

    const url = Hoot() + (update ? update_url : "create-institute");

    try {
      const response = await axios.post(url, formData, { withCredentials: true });
      toast.success(
        response?.data?.msg || (update ? "Instituição atualizada!" : "Instituição registada!")
      );

      // Só no registo (create) o endpoint devolve login/senha/licença -> gera o ficheiro
      if (!update && response?.data) {
        downloadInstituteReport(response.data);
        toast.success("Comprovativo de registo descarregado.");
      }

      setShow(false);
      ClickAllRefreshButtons();
    } catch (err) {
      console.clear();
      console.log(err?.response);
      const msg = err?.response?.data?.msg ? err?.response?.data?.msg : "Erro ao registrar instituição.";
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const disabledAll = loading || loadingFetch;

  return (
    <>
      <style>{uiStyles}</style>

      {/* Botão para abrir o modal */}
      <div onClick={() => setShow(true)} style={{ display: "inline-block" }}>
        {toggle_btn}
      </div>

      <Modal
        show={show}
        onHide={closeModal}
        centered
        backdrop="static"
        keyboard={!disabledAll}
        className="pretty-modal"
      >
        <Modal.Header closeButton={!disabledAll}>
          <div className="header-row" style={{ width: "100%" }}>
            <div className="header-left">
              <div className="avatar-wrap">
                <i
                  className={`bi ${update ? "bi-pencil-square" : "bi-building-add"}`}
                  style={{ color: "#5b5cff", fontSize: 18 }}
                />
              </div>

              <div>
                <div style={{ fontWeight: 650 }}>
                  {update ? "Editar Instituição" : "Registrar Instituição"}
                </div>
                <div className="title-sub">
                  Preenche os dados essenciais de forma organizada.
                </div>
              </div>
            </div>

            <div
              style={{
                width: 44,
                height: 44,
                borderRadius: 14,
                background: "rgba(91,92,255,.10)",
                border: "1px solid rgba(91,92,255,.18)",
                color: "#4338ca",
                display: "grid",
                placeItems: "center",
                fontWeight: 800,
              }}
              title="Instituição"
            >
              <i className="bi bi-building" />
            </div>
          </div>
        </Modal.Header>

        {/*  FORM envolve Body + Footer, mas só o Body tem scroll */}
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="body-scroll">
              {error && (
                <Alert variant="danger" className="mb-3" style={{ borderRadius: 14 }}>
                  {error}
                </Alert>
              )}

              {loadingFetch ? (
                <div className="d-flex align-items-center gap-2" style={{ color: "#64748b" }}>
                  <Spinner animation="border" size="sm" /> a carregar…
                </div>
              ) : null}

              <div className="form-grid">
                {/* Identificação */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-card-text" />
                    Identificação
                  </div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>
                        Nome da Instituição <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Nome da instituição"
                        value={formData.name}
                        onChange={(e) =>
                          setFormData({ ...formData, name: e.target.value })
                        }
                        disabled={disabledAll}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>
                        NIF <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="NIF"
                        value={formData.nif}
                        onChange={(e) =>
                          setFormData({ ...formData, nif: e.target.value })
                        }
                        disabled={disabledAll}
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Contacto */}
                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-telephone" />
                    Contacto
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      Email <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      required
                      placeholder="Email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      disabled={disabledAll}
                    />
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>
                      Telefone <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      required
                      placeholder="Telefone"
                      value={formData.phone}
                      onChange={(e) =>
                        setFormData({ ...formData, phone: e.target.value })
                      }
                      disabled={disabledAll}
                    />
                  </Form.Group>
                </div>

                {/* Localização */}
                <div className="cardlet">
                  <div className="cardlet-title">
                    <i className="bi bi-geo-alt" />
                    Localização
                  </div>

                  <Form.Group className="mb-2">
                    <Form.Label>
                      País <span className="req">*</span>
                    </Form.Label>
                    <Form.Select
                      required
                      value={formData.country}
                      onChange={(e) =>
                        setFormData({ ...formData, country: e.target.value })
                      }
                      disabled={disabledAll}
                    >
                      <option value="" disabled>
                        Selecione o país
                      </option>
                      <option value="Angola">Angola</option>
                      <option value="Brasil">Brasil</option>
                      <option value="Cabo Verde">Cabo Verde</option>
                      <option value="Guiné-Bissau">Guiné-Bissau</option>
                      <option value="Moçambique">Moçambique</option>
                      <option value="Portugal">Portugal</option>
                      <option value="São Tomé e Príncipe">São Tomé e Príncipe</option>
                      <option value="Timor-Leste">Timor-Leste</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group>
                    <Form.Label>
                      Província <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      required
                      placeholder="Província"
                      value={formData.state}
                      onChange={(e) =>
                        setFormData({ ...formData, state: e.target.value })
                      }
                      disabled={disabledAll}
                    />
                  </Form.Group>
                </div>

                {/* Endereço */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-map" />
                    Endereço
                  </div>

                  <Form.Group>
                    <Form.Label>
                      Endereço <span className="req">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      required
                      placeholder="Endereço"
                      value={formData.address}
                      onChange={(e) =>
                        setFormData({ ...formData, address: e.target.value })
                      }
                      disabled={disabledAll}
                    />
                    <div className="helper">
                      Rua, bairro, ponto de referência, etc.
                    </div>
                  </Form.Group>
                </div>

                {/* Escola Principal (mainschoolcode) */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title" style={{ justifyContent: "space-between" }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                      <i className="bi bi-diagram-3" />
                      Escola Principal (opcional)
                    </span>
                    {mainSchoolLocked && (
                      <span className="locked-pill">
                        <i className="bi bi-lock-fill" /> Definida automaticamente
                      </span>
                    )}
                  </div>

                  {mainSchoolLocked ? (
                    <Form.Group>
                      <Form.Label>Código da Escola Principal</Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          lockedSchoolName
                            ? `${lockedSchoolName} (${mainschoolcode})`
                            : mainschoolcode
                        }
                        disabled
                        readOnly
                      />
                      <div className="helper">
                        {loadingSchools
                          ? "A confirmar escola…"
                          : lockedSchoolName
                          ? "Este registo ficará associado a esta escola principal."
                          : "Aviso: não foi possível confirmar esta escola na lista de instituições do sistema."}
                      </div>
                    </Form.Group>
                  ) : (
                    <Form.Group>
                      <Form.Label>Escola Principal</Form.Label>
                      <Form.Select
                        value={formData.mainschool}
                        onChange={(e) =>
                          setFormData({ ...formData, mainschool: e.target.value })
                        }
                        disabled={disabledAll || loadingSchools}
                      >
                        <option value="">Nenhuma (esta é a escola principal)</option>
                        {schools.map((school) => (
                          <option
                            key={school.ed_institute_code}
                            value={school.ed_institute_code}
                          >
                            {school.ed_institute_name} ({school.ed_institute_code})
                          </option>
                        ))}
                      </Form.Select>
                      <div className="helper">
                        {loadingSchools
                          ? "A carregar escolas do sistema…"
                          : "Seleciona a escola já existente no sistema, caso esta instituição pertença a um grupo."}
                      </div>
                    </Form.Group>
                  )}
                </div>

                {/* Representante */}
                <div className="cardlet" style={{ gridColumn: "1 / -1" }}>
                  <div className="cardlet-title">
                    <i className="bi bi-person-badge" />
                    Representante (Diretor)
                  </div>

                  <div className="form-grid">
                    <Form.Group>
                      <Form.Label>
                        Nome <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        required
                        placeholder="Nome do representante"
                        value={formData.representative_name}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            representative_name: e.target.value,
                          })
                        }
                        disabled={disabledAll}
                      />
                    </Form.Group>

                    <Form.Group>
                      <Form.Label>
                        Email <span className="req">*</span>
                      </Form.Label>
                      <Form.Control
                        type="email"
                        required
                        placeholder="Email do representante"
                        value={formData.representative_email}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            representative_email: e.target.value,
                          })
                        }
                        disabled={disabledAll}
                      />
                    </Form.Group>
                  </div>
                </div>

                {/* Licença (hidden) */}
                <div className="d-none">
                  <Form.Group controlId="formLicenceType">
                    <Form.Label>Tipo de Licença</Form.Label>
                    <Form.Select
                      value={formData.licence_type}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          licence_type: e.target.value,
                        })
                      }
                      disabled={disabledAll}
                    >
                      <option value="0">Demonstração</option>
                      <option value="1">Trimestral</option>
                      <option value="2">Semestral</option>
                      <option value="3">Anual</option>
                    </Form.Select>
                  </Form.Group>
                </div>

                <div style={{ height: 6 }} />
              </div>
            </div>
          </Modal.Body>

          {/*  BOTÕES NO FOOTER DO MODAL (fora do scroll) */}
          <Modal.Footer>
            <div className="actions">
              <Button
                type="button"
                variant="outline-secondary"
                className="btn-soft"
                onClick={closeModal}
                disabled={disabledAll}
              >
                Cancelar
              </Button>

              <Button type="submit" variant="primary" disabled={disabledAll}>
                {loading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    A guardar...
                  </>
                ) : update ? (
                  "Atualizar"
                ) : (
                  "Registar"
                )}
              </Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}

export default RegisterAndUpdateInstituteModal;